module.exports = __webpack_public_path__ + "static/img/yx1.3d90c37f.png";